import React from 'react';
import { useSelector } from 'react-redux';
import { selectPlayers } from '../../../redux/gameSlice';

const eventPropertyToClass = {
  "health": "heart",
  "energy": "energy",
  "stars": "star"
};

export default function FlyingBubblesAnimated({ animationType, events }) {
  const players = useSelector(selectPlayers);
  let effects = [];

  for (const [index, event] of events.entries()) {
    const [playerId, property, diff] = event;
    const playerIdx = players.findIndex((player) => player.id === playerId);
    if (playerIdx === -1) {
      continue;
    }

    const player = players[playerIdx];
    if (diff > 0) {
      effects.push(<div
        key={`effect-${index}`}
        className={`game-sprite effect-ball ${eventPropertyToClass[property]} effect-ball-flying-player-${playerIdx + 1} ${animationType}`}></div>);
    }
    else if (diff < 0) {
      if (player[property] < 1) {
        continue; // Can't reduce what isn't there!
      }

      if (effects.indexOf("curse") < 0) {
        effects.push(<div
          key={`cursed-${index}`}
          className={`game-sprite effect-ball curse effect-ball-flying-player-${playerIdx + 1} ${animationType}`}></div>);
      }

      effects.push(<div
        key={`negative-effect-${index}`}
        className={`game-sprite negative-effect-ball losing-${eventPropertyToClass[property]} negative-effect-ball-flying-player-${playerIdx + 1} ${animationType}`}></div>);
    }
  }

  return effects;
}
